import React, { CSSProperties, ReactNode } from 'react'

import { colors } from '@lmc/common/constants'
// @ts-ignore
import { hexToRgbA } from '@lmc/common/utils'
import { ReactElement } from 'react'

type Props = {
  color?: string
  style?: object
  text: ReactNode
  testId?: string
}

export default function Banner({
  color = colors.informationblue,
  style,
  text,
  testId
}: Props): ReactElement {
  const bannerStyle = {
    ...styles.banner,
    background: hexToRgbA(color, 0.05),
    border: `1px solid ${hexToRgbA(color, 0.2)}`,
    color,
    ...style
  }

  return (
    <div style={bannerStyle as CSSProperties} data-testid={testId}>
      {text}
    </div>
  )
}

const styles = {
  banner: {
    borderRadius: 4,
    marginTop: 20,
    padding: 13,
    textAlign: 'center',
    width: '100%'
  }
}
